import _toConsumableArray from "C:/Users/Administrator/Desktop/work/space-0/fsplus-vue-workspace/foshan-street/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/channel/tag_icon.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c906e980"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  class: "topic-view"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "title"
  }, "热议话题", -1);
});

var _hoisted_3 = {
  class: "tag-wrap"
};
var _hoisted_4 = ["onClick"];

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});

import composition from '@/composition';
export default {
  props: {
    model: Object
  },
  setup: function setup(__props) {
    var props = __props;

    var _composition = composition(),
        ref = _composition.ref,
        request = _composition.request,
        openWebPage = _composition.openWebPage;

    var totals = [];
    var showMore = ref(false);
    var lists = ref([]);

    var getRandomArr = function getRandomArr(arr, count) {
      var newArr = [];

      for (var i = 0; i < count; i++) {
        if (arr.length > 0) {
          var idx = parseInt(Math.random() * arr.length);
          newArr.push(arr[idx]);
          arr.splice(idx, 1);
        }
      }

      return newArr;
    };

    var changeList = function changeList() {
      lists.value = getRandomArr(_toConsumableArray(totals), 4);
    };

    request.getTimelineTags(props.model.id, {}).then(function (res) {
      totals = res.data;
      changeList();
      showMore.value = totals.length > 4 ? true : false;
    }); // 打开话题

    var openTag = function openTag(item) {
      openWebPage('topic/index.html', item.id);
    };

    return function (_ctx, _cache) {
      return lists.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lists.value, function (item) {
        return _openBlock(), _createElementBlock("div", {
          class: "btn",
          key: item.id,
          onClick: function onClick($event) {
            return openTag(item);
          }
        }, [_hoisted_5, _createElementVNode("p", null, _toDisplayString(item.name), 1)], 8, _hoisted_4);
      }), 128))]), _withDirectives(_createElementVNode("div", {
        class: "change-btn",
        onClick: changeList
      }, "换一批", 512), [[_vShow, showMore.value]])])) : _createCommentVNode("", true);
    };
  }
};